import axios from 'axios';

const API = axios.create({
  baseURL: import.meta.env.VITE_INVESTMENTS_API_URL || 'http://localhost:5001',
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Ultima capsula del Panorama (FlowexPay x Progresion).
export async function getLatestCapsula() {
  const { data } = await API.get('/api/capsulas/latest');
  return data?.data || null;
}

// Historico de capsulas (para volverlas a escuchar).
export async function listCapsulas() {
  const { data } = await API.get('/api/capsulas');
  return data?.data || [];
}

// Envia una capsula al WhatsApp del cliente (la ultima, o una especifica por slug).
export async function sendCapsulaWhatsapp(phone, slug = null) {
  const { data } = await API.post('/api/capsulas/send-whatsapp', { phone, slug }, { timeout: 40000 });
  return data;
}

// Titulo humano de una capsula: usa el titulo propio (fecha del informe) si
// existe; si no, lo deriva del tipo y la fecha de creacion.
export function capsulaTitle(c) {
  if (c.title) return c.title;
  const fecha = new Date(c.createdAt).toLocaleDateString('es-CO', { day: 'numeric', month: 'long', year: 'numeric' });
  return c.type === 'panorama' ? `Panorama económico · ${fecha}` : `Cápsula · ${fecha}`;
}
